export default __webpack_public_path__ + "static/media/Image23.cee42592.png";